import React, { useState } from 'react';
import { cn } from '../../utils';

const Select = ({ children, value, onValueChange, onChange, ...props }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleChange = (e) => {
    const newValue = e.target.value;
    if (onChange) {
      onChange(e);
    }
    if (onValueChange) {
      onValueChange(newValue);
    }
  };

  return (
    <div className="relative">
      <select
        value={value}
        onChange={handleChange}
        className={cn(
          "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
          props.className
        )}
        {...props}
      >
        {children}
      </select>
    </div>
  );
};

const SelectContent = ({ children }) => <>{children}</>;

const SelectItem = ({ value, children, ...props }) => (
  <option value={value} {...props}>
    {children}
  </option>
);

const SelectTrigger = ({ children, ...props }) => <>{children}</>;

const SelectValue = ({ placeholder }) => <option value="">{placeholder}</option>;

export {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
};
